export var Size=/*#__PURE__*/function(a){return a.EXTRA_SMALL="xs",a.SMALL="sm",a.MEDIUM="md",a.LARGE="lg",a.EXTRA_LARGE="xl",a}({});